import type { Badge } from "@innoclouds/api";
import tinycolor from "tinycolor2";

export type BadgeShape = "pill" | "ribbon" | "sticker" | "icon_only";

export const BADGE_DARK_TEXT = "#2c3a4f";
export const BADGE_LIGHT_TEXT = "#ffffff";
export const BADGE_FALLBACK_BG = "#2c3a4f";
export const BADGE_BRIGHTNESS_THRESHOLD = 165;

export const isBadgeActive = (badge: Badge, now: number) => {
	if (badge.active_from && new Date(badge.active_from).getTime() > now) return false;
	if (badge.active_until && new Date(badge.active_until).getTime() <= now) return false;
	return true;
};

export const resolveBadgeShape = (badge: Badge, fallback: BadgeShape = "pill"): BadgeShape => {
	if (!badge.shape || badge.shape === "inherit") return fallback;
	return badge.shape as BadgeShape;
};

export const badgeBgColor = (badge: Badge) => badge.bg_color || BADGE_FALLBACK_BG;

export const badgeTextColor = (bg?: string | null) =>
	tinycolor(bg || BADGE_FALLBACK_BG).getBrightness() > BADGE_BRIGHTNESS_THRESHOLD ? BADGE_DARK_TEXT : BADGE_LIGHT_TEXT;

export { isVectorIcon } from "@innoclouds/ui";
